import React from "react";
import EmptySidebar from "../sidebar/EmptySidebar";
import EmptyNavbar from "../navbar/EmptyNavbar";
import EmptyFooter from "../footer/EmptyFooter";
import { Outlet } from "react-router-dom";

function EmptySidebarLayout(props) {
  //const location = useLocation();
  const mainPanel = React.useRef(null);
 
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
  }, []);
  return (
    <>
      <div className="wrapper">
        <EmptySidebar/>
        <div className="main-panel" ref={mainPanel}>
          <EmptyNavbar title=""/>
          <div className="content">
            {props.children}
            <Outlet/>
          </div>
          <EmptyFooter />
        </div>
      </div>
      
    </>
  );
}




export default EmptySidebarLayout;
